export class InformationType {
  informationTypeId?: number;
  clientITProfileId?: number;
  name?: string;
  recommendedConfidentialityLevel?: number;
  recommendedIntegrityLevel?: number;
  recommendedAvailabilityLevel?: number;
  selectedConfidentialityLevel?: number;
  selectedIntegrityLevel?: number;
  selectedAvailabilityLevel?: number;
  statement?: string;
}
